"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const script_1 = __importDefault(require("next/script"));
const react_1 = __importStar(require("react"));
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const libs_feature_toggle_1 = require("@hotelplan/libs.feature-toggle");
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
const getMetaInfo_1 = require("./getMetaInfo");
const PageViewProp_utils_1 = require("./PageViewProp.utils");
const tracking_utils_1 = require("./tracking.utils");
const trackPageView_1 = require("./trackingEvents/trackPageView");
const AppWithPageViewComponent = ({ pageProps, pageViewOptions, children }) => {
    var _a;
    const { exposeFeatures, version, omitScriptStrategy = false, splitPageViewEventFeatureToggle, } = pageViewOptions || {};
    const firstRenderRef = (0, react_1.useRef)(true);
    const firstRender = firstRenderRef.current;
    firstRenderRef.current = false;
    const pageViewData = (0, PageViewProp_utils_1.getPageViewProp)(pageProps);
    const deviceTypeProp = (0, libs_context_device_type_1.getDeviceTypePageProp)(pageProps);
    const deviceType = deviceTypeProp === libs_context_device_type_1.DeviceType.Desktop ? 'desktop' : 'mobile';
    const featureToggleData = (0, libs_feature_toggle_1.getFeatureTogglePageProp)(pageProps);
    const metaInfoData = (0, getMetaInfo_1.getMetaInfo)({ pageViewData, featureToggleData }, { exposeFeatures, version });
    const splitPageViewEvent = splitPageViewEventFeatureToggle &&
        ((_a = featureToggleData.config[splitPageViewEventFeatureToggle]) === null || _a === void 0 ? void 0 : _a.enabled);
    const pageViewEvent = (0, react_1.useMemo)(() => {
        var _a;
        return (0, trackPageView_1.getPageViewEvent)(Object.assign(Object.assign({}, pageViewData), { deviceType, title: ((_a = pageProps.meta) === null || _a === void 0 ? void 0 : _a.title) || '' }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageViewData, deviceType]);
    const pageLoadEvent = (0, react_1.useMemo)(() => {
        var _a;
        return (splitPageViewEvent &&
            (0, trackPageView_1.getPageLoadEvent)(Object.assign(Object.assign({}, pageViewData), { deviceType, title: ((_a = pageProps.meta) === null || _a === void 0 ? void 0 : _a.title) || '' })));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageViewData, deviceType, splitPageViewEvent]);
    (0, react_1.useEffect)(function onChangePageViewEffect() {
        if (firstRender)
            return;
        (0, libs_tracking_events_1.track)(pageViewEvent);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pageViewEvent]);
    (0, react_1.useEffect)(function trackingSubscriptionEffect() {
        return (0, libs_tracking_events_1.subscribeTracking)(event => {
            var _a;
            (_a = window === null || window === void 0 ? void 0 : window.duckTape) === null || _a === void 0 ? void 0 : _a.push(event);
        });
    }, []);
    if (!tracking_utils_1.gtmQueryString) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        firstRender ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(script_1.default, { strategy: omitScriptStrategy ? undefined : 'beforeInteractive', key: "gtm-init", dangerouslySetInnerHTML: {
                    __html: `
                var duckTape = window.duckTape = window.duckTape || [];
                duckTape.push(
                  ${JSON.stringify(metaInfoData)},
                  { 'gtm.start':new Date().getTime(), event:'gtm.js' },
                  ${JSON.stringify(splitPageViewEvent ? pageLoadEvent : pageViewEvent)}
                );
              `,
                } }),
            react_1.default.createElement(script_1.default, { strategy: omitScriptStrategy ? undefined : 'beforeInteractive', key: "gtm-script", defer: true, crossOrigin: "anonymous", src: `https://www.googletagmanager.com/gtm.js?l=duckTape&${tracking_utils_1.gtmQueryString}` }))) : null));
};
exports.default = AppWithPageViewComponent;
//# sourceMappingURL=AppWithPageViewComponent.js.map